/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeAuthRegistration = 'route-_auth-registration',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang)._auth.registration',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	firstName = 'firstName',
	lastName = 'lastName',
	email = 'email',
	subscribedToNewsletter = 'subscribedToNewsletter',
	inviteId = 'inviteId',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as REGISTRATION_I18NEXT,
	ROUTE_LOADER as REGISTRATION_ROUTE_LOADER,
	SEARCH_PARAMS as REGISTRATION_SEARCH_PARAMS,
}
